module.exports = __webpack_public_path__ + "img/06-img.cbaa9510.jpg";